exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a {\r\n    text-decoration: none;\r\n    font-size: 18px;\r\n    color: #c0c0c0;\r\n    cursor: pointer;\r\n    font-family: 'Corbel';\r\n}\r\n\r\ndiv {\r\n    margin-top: 10px;\r\n    float: right;\r\n}\r\n\r\n.selected {\r\n    color: #7a7a7a;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/header/languages/languages.component.css
// module id = 741
// module chunks = 1